export const RECOMMENDED_CONSTANTS = {
  RECOMMENDED_HEADER_TITLE: 'We Think You’ll Love These',
  CONTENT_DATA_MAX_LENGTH_TO_SCROLL: 4,
  BREAKPOINT: 1025,
  BREAKPOINT_768: 768,
  BREAKPOINT_480: 480,
  FADE_CARD_INDEX: 3,
  SLIDES_TO_SCROLL_MOBILE: 1,
  SLIDES_TO_SHOW_MOBILE_1024: 3,
  SLIDES_TO_SHOW_MOBILE_768: 2,
  SLIDES_TO_SHOW_MOBILE_480: 1,
  SLIDES_TO_SCROLL_MOBILE_480: 1,
  CAROUSAL_CONFIG: {
    SPEED: 200,
    SLIDES_TO_SHOW: 3,
    SLIDES_TO_SCROLL: 1,
  },
  PDP_RECOMMENDATIONS: {
    PDP_SPEED: 200,
    PDP_SLIDES_TO_SHOW: 4,
    PDP_CONTENT_DATA_MAX_LENGTH_TO_SCROLL: 5,
    PDP_SLIDES_TO_SHOW_1024: 3,
  },
};

const {
  BREAKPOINT,
  BREAKPOINT_768,
  BREAKPOINT_480,
  SLIDES_TO_SHOW_MOBILE_1024,
  SLIDES_TO_SHOW_MOBILE_768,
  SLIDES_TO_SHOW_MOBILE_480,
  SLIDES_TO_SCROLL_MOBILE_480,
  CAROUSAL_CONFIG: { SLIDES_TO_SCROLL },
} = RECOMMENDED_CONSTANTS;

export const RESPONSIVE_CONFIG = [
  {
    breakpoint: BREAKPOINT,
    settings: {
      slidesToShow: SLIDES_TO_SHOW_MOBILE_1024,
      slidesToScroll: SLIDES_TO_SCROLL,
      arrows: true,
      swipeToSlide: true,
    },
  },
  {
    breakpoint: BREAKPOINT_768,
    settings: {
      slidesToShow: SLIDES_TO_SHOW_MOBILE_768,
      arrows: false,
      swipeToSlide: true,
    },
  },
  {
    breakpoint: BREAKPOINT_480,
    settings: {
      slidesToShow: SLIDES_TO_SHOW_MOBILE_480,
      slidesToScroll: SLIDES_TO_SCROLL_MOBILE_480,
    },
  },
];
